import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiGet } from "../lib/api";
import { ListingCard } from "../components/ListingCard";
import { Button, EmptyState } from "../components/ui";

export function MyListingsPage() {
  const navigate = useNavigate();
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    apiGet("/my-listings")
      .then((data) => {
        if (!cancelled) setListings(data.listings || []);
      })
      .catch((err) => {
        if (!cancelled) setError(err.message);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const active = listings.filter((l) => l.status !== "sold");
  const sold = listings.filter((l) => l.status === "sold");

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-2xl font-bold text-slate-800">My Gear</h1>
        <Button onClick={() => navigate("/gear/sell")}>List an item</Button>
      </div>

      {loading ? (
        <p className="text-slate-400">Loading…</p>
      ) : error ? (
        <EmptyState title="Couldn't load your listings">
          {error}
        </EmptyState>
      ) : listings.length === 0 ? (
        <EmptyState title="You haven't listed anything yet">
          Sell your old cleats, jerseys, and gear to other SSA members.
        </EmptyState>
      ) : (
        <div className="space-y-6">
          <Section title={`Active (${active.length})`} items={active} />
          {sold.length > 0 && <Section title={`Sold (${sold.length})`} items={sold} />}
        </div>
      )}
    </div>
  );
}

function Section({ title, items }) {
  if (!items.length) return null;
  return (
    <div>
      <h2 className="text-sm font-semibold text-slate-500 uppercase tracking-wide mb-2">{title}</h2>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
        {items.map((l) => (
          <ListingCard key={l.id} listing={l} />
        ))}
      </div>
    </div>
  );
}
